import React from 'react'
import { GatsbyImage as Img } from 'gatsby-plugin-image'
import { css } from 'theme-ui'
import rv from '@components/utils/buildResponsiveVariant'

const CardMediaImage = ({
  variant,
  loading,
  image,
  title,
  isSymposium,
  isHeritage
}) => {
  return (
    <Img
      image={image}
      loading={loading}
      alt={title}
      style={isHeritage || isSymposium ? { borderRadius: `18px` ,maxHeight:'400px'} : {}}
      css={css({
        height: `full`,
        verticalAlign: `middle`, //avoid baseline gap
        img: {
          bg: `omegaLighter`
        },
        variant: rv(variant, 'image')
      })}
    />
  )
}
CardMediaImage.defaultProps = {
  loading: 'lazy'
}

export default CardMediaImage
